import React, { forwardRef } from 'react';
import StaticMapStyled from './bundle.esm2.js';
import { generateStaticMap } from './bundle.esm3.js';
import Image from '../Image/bundle.esm.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const StaticMap = forwardRef((props, ref) => {
  const _a = props, {
    googleMapsKey,
    markers,
    alt = "static map",
    zoom,
    center,
    className,
    width,
    height,
    poi = true
  } = _a, rest = __objRest(_a, [
    "googleMapsKey",
    "markers",
    "alt",
    "zoom",
    "center",
    "className",
    "width",
    "height",
    "poi"
  ]);
  if (!center && (!markers || !(markers == null ? void 0 : markers.length))) {
    console.error(
      "You must provide markers prop or center prop and zoom prop to StaticMap component"
    );
  }
  return /* @__PURE__ */ React.createElement(StaticMapStyled, {
    className: `StaticMap ${className}`
  }, /* @__PURE__ */ React.createElement(Image, __spreadProps(__spreadValues({
    className: "StaticMap__image"
  }, rest), {
    ref,
    alt,
    image: generateStaticMap({
      height,
      width,
      markers,
      googleMapsKey,
      zoom,
      center,
      poi
    }),
    width,
    height
  })));
});
StaticMap.defaultProps = {
  className: "",
  alt: "static map",
  poi: true
};

export { StaticMap as default };
//# sourceMappingURL=bundle.esm.js.map
